export const miniProgramPageNames = {
  examAnswer: '/subPages/exam/answer/index',
  examResult: '/subPages/exam/result/index',
  examAnalyze: '/subPages/exam/analyze/index',
  feedBack: '/pages/feedback/feedback',
  examList: '/pages/examList/examList',
  chapterList: '/pages/level/pages/index/index',
  wrongCollection: '/pages/record/record',
  punchInDailyActivity: '/subPages/studyCheck/studyCheck',
  login: '/subPages/bindWechat/bindWechat',
};
